import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { OverlayService } from '../services/overlay.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { Http } from '@angular/http'
import { HttpHelperService } from '../services/helpers/http-helper.service';

import { SearchService } from "../services/search.service";
import { UserService } from '../services/user.service';
import { PagerService } from '../services/pagination.service';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    animations: [fadeInUp]
})
export class SearchComponent implements OnInit {

    isLoggedIn: Boolean = false
    loginRedirectPath: String = ''
    showResults: Boolean = false
    resultsProviders: any
    resultsProvidersStored: any
    resultsCourse: any
    searchByOptions: Array<any> = ['Qualification', 'Course code']
    filterOptions: Array<any> = ['Most Reviewed', 'Top Rated (Student or Graduate)', 'Top Rated (Employer)', 'A-Z']
    searchForm: FormGroup

	searchProviderTimeout: any
	searchProviderValue: String = ''

    public value:any = {};
    public courseCodeOptions: Array<any> = []
    public qualificationOptions: Array<any> = []
    pagedResults: Array<Object>
    offset: number = 0
    limit: number = 20

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private fbuilder: FormBuilder,
        private overlayService: OverlayService,
        private searchService: SearchService,
        private http: Http,
        private httpHelperService: HttpHelperService,
        private userService: UserService,
        private pagerService: PagerService
    ) {
    }

    ngOnInit() {
        this.isLoggedIn = this.userService.isLoggedin()
        this.searchForm = this.fbuilder.group({
            'searchBy': [null],
            'courseId': [null],
            'qualification': [null],
            'careers': [null]
        })
        this.searchFor(this.searchByOptions[0])

        this.fetchSearchOptions()
    }

    fetchSearchOptions() {
        this.http.get('/api/search/searchoptions', { headers: this.httpHelperService.headers(false) })
            .subscribe(response => {
                let courses = response.json()
                courses.forEach(elem => {
                    let obj1 = {
                        id: elem._id,
                        text: elem.courseCode,
                    }
                    let obj2 = {
                        id: elem._id,
                        text: elem.name
                    }
                    this.courseCodeOptions.push(obj1)
                    this.qualificationOptions.push(obj2)
                })
            }, err => {
                console.log(err)
            })
    }

    searchFor(value) {
        this.searchForm.controls['searchBy'].setValue(value)
    }

    filterSelect(val = null) {
        if (val) {
            val = val.target.value
        } else {
            val = 'Most Reviewed'
        }
		this.resultsProvidersStored.sort((a, b) => {
            let returnVal = 0
            if (val === 'A-Z') {
                if (a.name < b.name) returnVal = -1;
                if (a.name > b.name) returnVal = 1;
            } else if (val === 'Top Rated (Student or Graduate)') {
                if (a.reviewCount.student < b.reviewCount.student) returnVal = 1;
                if (a.reviewCount.student > b.reviewCount.student) returnVal = -1;
            } else if (val === 'Top Rated (Employer)') {
                if (a.reviewCount.employer < b.reviewCount.employer) returnVal = 1;
                if (a.reviewCount.employer > b.reviewCount.employer) returnVal = -1;
            } else if (val === 'Closest to me') {
                if (Number(a.distance) < Number(b.distance)) returnVal = -1;
                if (Number(a.distance) > Number(b.distance)) returnVal = 1;
            } else if (val === 'Most Reviewed') {
                if (a.reviewCount.total < b.reviewCount.total) returnVal = 1;
                if (a.reviewCount.total > b.reviewCount.total) returnVal = -1;
            }
            return returnVal;
        })

		this.resultsProviders = this.resultsProvidersStored
		if (this.searchProviderValue !== '') {
			this.findSearchedProvider(this.searchProviderValue)
		} else {
			this.offset = 0
			this.findAll(this.offset, this.limit)
		}
    }

    submitSearchForm(isValid, submission) {

        if (isValid) {
            this.showResults = true
            this.resultsCourse = null
            this.resultsProviders = []

            const body = submission
            this.searchService.getSearchResults(body).then((res: any) => {
                if (res && res.providers) {
                    this.resultsCourse = res.course
                    let tempProviders = JSON.parse(JSON.stringify(res.providers))
                    tempProviders.forEach(provider => {
                        let reviewCountForStudent = provider.reviewCount.student
                        if (reviewCountForStudent) {
                            let numStr = reviewCountForStudent + ''
                            if (numStr.indexOf('.') !== -1) {
                                reviewCountForStudent = reviewCountForStudent.toFixed(1)
                                provider.reviewCount.student = reviewCountForStudent
                            }
                        }
                    });
                    this.resultsProviders = tempProviders
					this.resultsProvidersStored = this.resultsProviders
                    if (this.resultsProviders.length === 0) {
                        this.pagedResults = []
                    } else {
                        this.findAll(0, this.limit)
                    }
                    this.getLocation()
                }
            }).catch(err => {
                this.resultsCourse = { error: true }
            })
        }
    }

    getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                if (!this.filterOptions.includes('Closest to me')) {
                    this.filterOptions.push('Closest to me')
                }
                this.resultsProviders = this.resultsProviders.map(item => {
                    const newItem = item
                    if (item.location && item.location.Latitude && item.location.Longitude) {
                        newItem.distance = this.calcDistance(position.coords.latitude, position.coords.longitude, item.location.Latitude, item.location.Longitude)
                    }
                    return newItem
                });
            });
        }
    }

    calcDistance(lat1, lon1, lat2, lon2) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            let radlat1 = Math.PI * lat1 / 180;
            let radlat2 = Math.PI * lat2 / 180;
            let theta = lon1 - lon2;
            let radtheta = Math.PI * theta / 180;
            let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344
            return dist.toFixed(0);
        }
    }

	findSearchedProvider(value) {
		clearTimeout(this.searchProviderTimeout);
		this.searchProviderTimeout = setTimeout(() => {
			this.searchProviderValue = value.toLowerCase()
			this.resultsProviders = this.resultsProvidersStored.filter((item) => {
				let name = item.name.toLowerCase()
				if (name.includes(this.searchProviderValue)) {
					return name
				} else {
					return
				}
			});
			this.offset = 0
			if (this.searchProviderValue !== '') {
				this.limit = 1000
			} else {
				this.limit = 20
			}
			this.findAll(this.offset, this.limit)
		}, 600)
	}

    seeAllReviews(link: String) {
        if (this.isLoggedIn) {
            this.router.navigate(['/course/' + link])
        } else {
            this.loginRedirectPath = '/course/' + link
            setTimeout(function () {
                document.getElementById('notloggedin-overlay').classList.add('is-block')
            }, 10)
            setTimeout(function () {
                document.getElementById('notloggedin-overlay').classList.add('is-visible')
            }, 20)
        }
    }

    selected(value:any, submission: any):void {
        this.searchForm.controls['courseId'].setValue(value.id)
        this.searchForm.controls['courseId'].updateValueAndValidity()
        this.submitSearchForm(this.searchForm.valid, this.searchForm.value)
    }

    removed(value:any):void {
        // console.log('Removed value is: ', value);
    }

    typed(value:any):void {
        // console.log('New search input: ', value);
    }

    refreshValue(value:any):void {
        this.value = value;
    }

    redirectToLogin(route, queryParams) {
        const routes = []
        routes.push(route)
        if (queryParams) {
            this.router.navigate(routes, {queryParams: {redirect: this.loginRedirectPath}})
        } else {
            this.router.navigate(routes)
        }
    }

    onPageChange(offset) {
        this.offset = offset
        this.findAll(this.offset, this.limit)
        let elems = document.getElementsByClassName('c-search__result_content') as HTMLCollectionOf<HTMLElement>
        if (elems) {
            let scrollX = elems[0].offsetLeft
            let scrollY = elems[0].offsetTop + 400
            window.scrollTo(scrollX, scrollY)
        }
    }

    findAll(offset: number, limit: number) {
		let startIndex = offset
		let endIndex = Math.min(startIndex + limit - 1, this.resultsProviders.length - 1)
		this.pagedResults = this.resultsProviders.slice(startIndex, endIndex + 1)
    }

    closeOverlay() {
        document.getElementById('notloggedin-overlay').classList.remove('is-visible')
        setTimeout(function () {
            document.getElementById('notloggedin-overlay').classList.remove('is-block')
        }, 500)
    }
}



// WEBPACK FOOTER //
// ./src/app/search/search.component.ts